import React, { createContext, useReducer, useState } from "react";
import { verificationReducer } from "../reducers/verificationReducer";

export const VerificationContext = createContext();

const VerificationContextProvider = (props) => {
  const [verified, setVerified] = useState(false);
  const [verify, dispatch] = useReducer(verificationReducer, {
    token: "",
    isVerified: false,
  });

  return (
    <VerificationContext.Provider
      value={{ verify, dispatch, verified, setVerified }}
    >
      {props.children}
    </VerificationContext.Provider>
  );
};

export default VerificationContextProvider;
